import React from "react";
import NewPayslip from "./NewPayslip/NewPayslip";

function PayslipWithSelector({ showSelector }) {
  return <NewPayslip forceShowSelector={showSelector} />;
}

export default PayslipWithSelector;
